import React from 'react';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import { RuntimeEnvironment } from '@wix/da-shared-react/pkg/types';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import SharedDeviationPage from '@wix/da-shared-react/pkg/DeviationPage';
import { PapiDeviation } from '@wix/da-types-papi';
import './App.scss';

export interface Props {
  language: string;
  seoCanonical: string;
  deviation?: PapiDeviation;
  environment?: RuntimeEnvironment;
  appLoaded: () => void;
}

class App extends React.Component<Props> {
  componentDidMount() {
    this.props.appLoaded();
  }

  render() {
    const { deviation, language, environment, seoCanonical } = this.props;

    return (
      <DaApp
        headTags={{
          pageTitle: 'DeviantArt', // placeholder, real title is set in DeviationPAge
          language,
          environment,
          pageUrl: seoCanonical,
        }}
        backToTop={{ scrollToY: 0 }}
        isDuperbrowseEnabled={false}
        disablePageWideNotifications
      >
        <ErrorBoundary>
          <SharedDeviationPage
            deviation={deviation}
            environment={environment}
          />
        </ErrorBoundary>
      </DaApp>
    );
  }
}

export default App;
